import { useNavigate } from "react-router-dom";
import { useLogout } from "../../auth/services/AuthService";
import "./ServerUnavailable.scss";

interface ServerUnavailableProps {
  onRetry?: () => void;
  isRetrying?: boolean;
  title?: string;
  message?: string;
}

//Fehleranzeige fuer Server- oder Netzwerkfehler (5xx, keine Antwort).
export default function ServerUnavailable({
  onRetry,
  isRetrying = false,
  title = "Server nicht erreichbar",
  message = "Die Daten konnten gerade nicht geladen werden. Bitte versuche es in einem Moment erneut.",
}: ServerUnavailableProps) {
  const navigate = useNavigate();
  const logoutMutation = useLogout();

  const handleLogoutAndLeave = () => {
    // Zur Startseite navigieren – auch wenn der Logout-Request selbst
    // fehlschlaegt (z. B. Backend komplett offline).
    logoutMutation.mutate(undefined, {
      onSettled: () => navigate("/", { replace: true }),
    });
  };

  const isBusy = isRetrying || logoutMutation.isPending;

  return (
    <div className="server-unavailable" role="alert">
      <div className="server-unavailable__card">
        <div className="server-unavailable__icon-wrapper">
          <span className="server-unavailable__icon" aria-hidden="true">
            ⚠️
          </span>
        </div>

        <h2 className="server-unavailable__title">{title}</h2>
        <p className="server-unavailable__message">{message}</p>

        <div className="server-unavailable__actions">
          {onRetry && (
            <button
              type="button"
              className="server-unavailable__retry"
              onClick={onRetry}
              disabled={isBusy}
            >
              {isRetrying ? "Wird geladen..." : "Erneut versuchen"}
            </button>
          )}
          <button
            type="button"
            className="server-unavailable__leave"
            onClick={handleLogoutAndLeave}
            disabled={isBusy}
          >
            {logoutMutation.isPending
              ? "Wird abgemeldet..."
              : "Abmelden & zur Startseite"}
          </button>
        </div>
      </div>
    </div>
  );
}
